<template>
  <div class="alarm-wrap">
    <div
      v-if="isClick && alarmInfoTip"
      class="alarm-info-new"
      @click.stop="toViewAlarmInfo(alarmInfoTip.device_no)"
    >
      <div class="info">
        <div class="view-info">
          <span v-if="false"
            >{{ alarmInfoTip.device_name || "--" }}区域发生{{
              alarmInfoTip.eventName || "--"
            }}事件,启动闭环管控流程</span
          >
          <p>{{ alarmInfoTip.warn_time }}</p>
          <p style="word-break: break-all">
            {{
              alarmInfoTip.device_name +
              "(" +
              alarmInfoTip.device_no +
              ")监测区域发生" +
              alarmInfoTip.eventName
            }}
          </p>
          <p>{{ "报警数值 " + alarmInfoTip.value }}</p>
        </div>
        <div class="to-view">
          <img src="./img/go.png" alt="" />
        </div>
      </div>
    </div>
    <div class="alarm-details-left" v-if="viewWarnInfoStatus">
      <div class="event-info-wrap">
        <div class="title">事件概述</div>
        <div class="event-info">
          <p>{{ alarmInfoTip.warn_time }}</p>
          <p style="word-break: break-all">
            {{
              alarmInfoTip.device_name +
              "(" +
              alarmInfoTip.device_no +
              ")监测区域发生" +
              alarmInfoTip.eventName
            }}
          </p>
          <p>{{ "报警数值 " + alarmInfoTip.value }}</p>
        </div>
      </div>
      <div class="video-info-wrap" v-show="viewWarnInfoStatus">
        <div class="title">现场视频画面</div>
        <div class="video">
          <vdm-cvr ref="vdmNode" cvrWidth="374px" cvrHeight="210px"></vdm-cvr>
        </div>
        <!-- <div class="no-data" v-else>暂无数据</div> -->
      </div>
    </div>

    <div class="alarm-details-right" v-if="viewWarnInfoStatus">
      <div class="title">闭环管控过程信息</div>
      <div
        class="event-info"
        v-if="alarmInfoTip && warnRecord && alarmInfoTip.device_name"
      >
        <p>{{ alarmInfoTip.warn_time }}</p>
        <p style="word-break: break-all">
          {{
            alarmInfoTip.device_name +
            "(" +
            alarmInfoTip.device_no +
            ")监测区域发生" +
            alarmInfoTip.eventName
          }}
        </p>
        <p>{{ "报警数值 " + alarmInfoTip.value }}</p>
        <p class="modeDesc">{{ warnRecord.modeDesc || "" }}</p>
      </div>
      <div
        class="event-list"
        v-show="warnRecord && warnRecord.record.length > 0"
        v-for="(item, index) in warnRecord.record"
        :key="index"
      >
        <div class="time">{{ item.processTime }}:</div>
        <div class="info">
          {{ item.processDes }}
        </div>
      </div>
    </div>
    <!-- <div class="vdmChart" v-show="viewWarnInfoStatus === 1">
      <SingleVdm
        v-if="viewWarnInfoStatus === 1"
        :deviceNo="vdm150DeviceNo"
        :startTime="timeArr[0]"
        :endTime="timeArr[1]"
      />
    </div> -->

    <!-- <div @click="curLocation">记录当前位置</div>
    <div @click="backToLocation">回到告警位置</div>
    <div @click="backToLocation1">回到初始位置</div> -->
  </div>
</template>

<script>
import {
  switchAreaWarn, //开关告警区域
  switchCarCamera, // 切换相机到洗车机
  currentLocationFun, // 获取当前相机位置
  backToLocationFun, // 相机移动到指定位置
  cameraMoveFun, // 相机移动
  switchSingleHL, // 单个设备高亮
} from "@/assets/js/unity3D/shed.js";
import SingleVdm from "@/modules/unorganizedComponents/vdmBar/singleVdm.vue";
import vdmCvr from "@/modules/videoComponents/component/vdmCvr2.vue";
import { dateFormat } from "@/utils/tools.js";

export default {
  props: [""],
  components: { SingleVdm, vdmCvr },
  inject: ["updateNvrInfoBox"],
  data() {
    return {
      warnStatus: false,
      videoUrl: "",
      alarmTimer: null,
      tipsTimer: null,
      timerLocation: null,
      areaWarnJson: "", //  [0, '4', 'AreaWarn']
      alarmInfoTip: {},
      deviceMapJson: "",
      viewWarnInfoStatus: false, // 查看告警详情
      showAlarmPop: false,
      locationJson: "",
      isClick: false,
      timeArr: [
        dateFormat("YYYY-mm-dd", new Date()) + " 00:00:00",
        dateFormat("YYYY-mm-dd HH:MM:SS", new Date()),
      ],
      vdm150DeviceNo: "",
      cvrInfo: {},
      // vdm150DeviceNo: 'BMEVDM0A210521072'
    };
  },

  watch: {
    alarmInfoTip: {
      handler(newVal, oldVal) {
        if (this.tipsTimer) {
          clearTimeout(this.tipsTimer);
        }
        // console.log("newVal", newVal);
        if (!this.showAlarmPop && newVal != oldVal) {
          // this.backToLocation1()
          this.tipsTimer = setTimeout(() => {
            this.cancleAreaWarn();
          }, 10000);
        }
      },
      deep: true,
    },
  },

  created() {
    this.openWarnFun();
  },

  mounted() {
    this.$globalClick(this.moreSetupMenuRemove);
  },

  beforeUnmount() {
    if (this.alarmTimer) {
      clearInterval(this.alarmTimer);
    }
    if (this.tipsTimer) {
      clearTimeout(this.tipsTimer);
    }
  },

  methods: {
    moreSetupMenuRemove(e) {
      // console.log("nihao123", e);
      if (this.timerLocation) {
        clearTimeout(this.timerLocation);
      }
      // 自动回到全景视角
      if (this.showAlarmPop) {
        this.backToLocation1();
      }
    },

    // 开启告警
    openWarnFun() {
      let that = this;
      this.getDeviceFrontMapping();
      this.getRegionNo();
      if (this.alarmTimer) {
        clearInterval(this.alarmTimer);
      }
      this.alarmTimer = setInterval(() => {
        that.getRegionNo();
      }, 15 * 1000); // 请求间隔
    },
    // 关闭告警并回到全景视角
    closeWarnFun() {
      this.backToLocation1();
      if (this.alarmTimer) {
        clearInterval(this.alarmTimer);
      }
    },
    // 获取最新告警区域
    async getRegionNo() {
      let findWarningAngleUrl =
        CONFIG.requestShed + this.$apiOpt.findWarningAngle;
      let regionNo = await this.$apiUtils.get(findWarningAngleUrl, {
        startTime: this.$moment(new Date().getTime() - 3600 * 1000 * 1).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        endTime: this.$moment(new Date().getTime()).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
        shedNo: "42_101",
      });

      if (this.areaWarnJson) {
        switchAreaWarn(this.locationJson, false);
        this.locationJson = "";
      }
      if (regionNo) {
        // if (
        //   new Date().getTime() - new Date(regionNo.warn_time).getTime() <
        //   1000 * 60 * 60 * 1
        // ) {
        //   return;
        // }

        // 告警设备
        this.vdm150DeviceNo = regionNo.deviceNo;
        this.isClick = true;
        if (regionNo.region_no) {
          // 告警数据
          this.alarmInfoTip = regionNo;
          // 告警区域ID
          this.areaWarnJson = regionNo.region_no;
          this.locationJson = regionNo.front_id.replace("Area", "AreaWarn");
          switchAreaWarn(this.locationJson, true);
        }
      } else {
        this.alarmInfoTip = "";
        // this.$message.warning("未获取到告警设备关联区域");
      }
    },

    // 获取当前告警详情
    async getFindWarnInfo() {
      let findWarnInfoMoreUrl =
        CONFIG.requestShed + this.$apiOpt.findWarnInfoMore;
      let warnListInfo = await this.$apiUtils.get(findWarnInfoMoreUrl, {
        deviceNo: this.alarmInfoTip.device_no,
        warnTime: this.alarmInfoTip.warn_time,
        regionNo: this.alarmInfoTip.region_no,
        warningAngle: this.alarmInfoTip.warning_angle
        // 测试数据
        // deviceNo: "BMEVDM5J210502147",
        // warnTime: "2022-04-19 06:11:47",
        // regionNo: "42_101_003",
        // warningAngle: 120,
        // 自动
        // warnTime: "2022-04-22 18:08:12",
        // 手动
        // warnTime: "2022-05-02 06:44:06",
      });
      // console.log("alarmInfo111", alarmInfo);
      this.warnList = [];
      if (warnListInfo) {
        this.warnRecord = warnListInfo;
        this.viewWarnInfoStatus = true;
        if (warnListInfo.videoPlay && warnListInfo.videoPlay.channel) {
          this.$nextTick(() => {
            this.cvrInfo = warnListInfo.videoPlay;
            this.$refs.vdmNode.getData(this.cvrInfo);
          });
        }
        // if (warnListInfo.warnList) {
        //   this.warnList = warnListInfo.warnList;
        // } else {
        //   this.getCvrIpInfo2(warnListInfo.cameraInfo);
        // }
        // this.isClick = false;
      } else {
        this.$message({
          message: "目前暂无闭环告警数据详情信息！",
          type: "warning",
        });
      }
    },
    // 通过设备编码获取录像参数
    async getCvrIpInfo(item) {
      let findCvrIpUrl = CONFIG.requestName + this.$apiOpt.findCvrIp;
      let cvrInfo = await this.$apiUtils.get(findCvrIpUrl, {
        cameraId: item.camera_id,
      });
      if (cvrInfo) {
        this.$nextTick(() => {
          this.cvrInfo = {
            lastTime: this.alarmInfoTip.startTime,
            recodeDate: this.alarmInfoTip.startTime,
            channelId: cvrInfo.channel,
            // lastTime: "2022-03-21 15:09:27",
            // recodeDate: "2022-03-21 15:09:27",
            // channelId: 301,
            nvrIp: cvrInfo.ip,
          };
        });
      }
    },
    // 相机飞跃到告警设备正视角
    toViewAlarmInfo() {
      this.showAlarmPop = true;
      let that = this;
      // this.cameraMove();
      // 无告警区域
      if (!this.areaWarnJson) {
        if (
          this.alarmInfoTip &&
          this.alarmInfoTip.eventName.indexOf("VDM3000") > -1
        ) {
          let vdm3500ObjList = this.$shedEquipRelate.data.vdm3500;
          let vdm3500Obj = Object.keys(vdm3500ObjList).filter((i) => {
            return vdm3500ObjList[i] == this.vdm150DeviceNo;
          })[0];
          backToLocationFun(vdm3500Obj);
          this.viewWarnInfoStatus = 1;
        } else {
          backToLocationFun(this.locationJson);
        }
        // 有告警区域
      } else {
        this.getFindWarnInfo();
        backToLocationFun(this.locationJson);
      }
      if (this.tipsTimer) {
        clearTimeout(this.tipsTimer);
      }
      if (this.timerLocation) {
        clearTimeout(this.timerLocation);
      }
      // 自动回到全景视角
      this.timerLocation = setTimeout(() => {
        that.backToLocation1();
      }, 30000);
    },

    // 定位相机视角
    curLocation() {
      currentLocationFun();
    },

    // 相机飞到告警区域正视角
    backToLocation(pos) {
      // let locationJson = "1,4,AreaWarn"; // 测试告警区域;
      backToLocationFun(this.locationJson);
    },

    // 设备映射关系
    async getDeviceFrontMapping(deviceNo) {
      let getDeviceFrontMappingUrl =
        CONFIG.requestShed + this.$apiOpt.getDeviceFrontMapping;
      let mapResult = await this.$apiUtils.get(getDeviceFrontMappingUrl, {
        customerId: this.$store.state.customerId,
      });
      let frontId = "";
      // console.log("mapResult", mapResult);
      if (mapResult && mapResult.length > 0) {
        for (let item of mapResult) {
          for (let key of item.deviceNo) {
            if (key == deviceNo) {
              frontId = item.frontId;
            }
          }
        }
      }
      return frontId;
    },

    // 相机回到全景视角
    backToLocation1() {
      this.showAlarmPop = false;
      this.cvrInfo.nvrIp = "";
      let locationJson = "0,0,0"; // 全景视角
      backToLocationFun(locationJson);
      this.viewWarnInfoStatus = false;
      switchAreaWarn(this.locationJson, false);
      if (this.deviceMapJson) {
        switchSingleHL(this.deviceMapJson, false); // 单个设备高亮
      }
    },

    // 取消告警区域
    cancleAreaWarn() {
      // this.alarmInfo = null;
      // this.alarmInfoTip = null;
      // let AreaWarnJson = [0, '4', 'AreaWarn']
      switchAreaWarn(this.locationJson, false);
    },
  },
};
</script>

<style scoped lang="scss">
.alarm-wrap {
  .alarm-info {
    position: fixed;
    left: 10%;
    top: 50%;
    transform: translateY(-50%);
    height: 161px;
    width: 344px;
    padding: 20px 10px;
    box-sizing: border-box;
    background: url("./img/warnBg.png") no-repeat center center;
    background-size: 100% 100%;
    cursor: pointer;
    .alarm-title {
      position: absolute;
      top: 4px;
      left: 50px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #f56666;
      line-height: 15px;
    }
    .info {
      margin-top: 15px;
      font-size: 15px;
      font-weight: 400;
      color: #add8ff;
      line-height: 21px;
      display: flex;
      align-items: center;
    }
    .view-info {
      flex: 1;
      color: #add8ff;
      p {
        word-break: "";
        white-space: "";
      }
    }
    .info-left {
      display: flex;
      flex-direction: column;
      justify-content: center;
      width: 100px;
      align-items: center;
      img {
        height: 32px;
        width: 36px;
      }
      span {
        font-size: 15px;
        font-weight: 400;
        color: #f56666;
        line-height: 28px;
      }
    }
    .to-view {
      margin-top: 15px;
      position: relative;
      color: #50e3c2;
      img {
        height: 26px;
        width: 171px;
      }
      .view-detail {
        position: absolute;
        left: 30px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .event-name {
      color: yellow;
    }
  }

  .alarm-info-new {
    position: fixed;
    left: 10%;
    top: 50%;
    transform: translateY(-50%);
    height: 580px;
    width: 505px;
    padding: 20px 10px;
    box-sizing: border-box;
    background: url("./img/warn.png") no-repeat center center;
    background-size: 100% 100%;
    cursor: pointer;
    .alarm-title {
      position: absolute;
      top: 4px;
      left: 50px;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #f56666;
      line-height: 15px;
    }
    .info {
      margin-top: 53px;
      font-size: 19px;
      font-weight: 400;
      color: #ffd9af;
      line-height: 27px;
      display: flex;
      align-items: center;
      flex-direction: column;
      width: 100%;
      justify-content: center;
      padding: 0 80px;
      box-sizing: border-box;
      position: absolute;
      top: 230px;
      left: 0px;
    }
    .view-info {
      flex: 1;
      color: #ffd9af;
    }
    .to-view {
      margin-top: 15px;
      position: relative;
      color: #50e3c2;
      img {
        height: 31px;
        width: 220px;
      }
      .view-detail {
        position: absolute;
        left: 30px;
        top: 50%;
        transform: translateY(-50%);
      }
    }
    .event-name {
      color: yellow;
    }
  }

  .title {
    font-size: 21px;
    font-weight: 500;
    color: #dddddd;
    line-height: 29px;
    width: 100%;
    text-align: center;
    position: relative;
    margin-bottom: 20px;
    &::before {
      content: "";
      height: 2px;
      width: 40px;
      background: #4a90e2;
      position: absolute;
      top: 37px;
      left: 50%;
      transform: translateX(-50%);
    }
  }

  .alarm-details-left {
    position: fixed;
    left: 35%;
    top: 50%;
    transform: translate(-100%, -50%);
    .event-info-wrap {
      width: 421px;
      max-height: 400px;
      background: #000000;
      box-shadow: 0px 8px 16px 0px rgba(74, 144, 226, 0.31);
      border-radius: 2px;
      border: 1px solid #4a90e2;
      padding: 33px 40px;
      box-sizing: border-box;
    }

    .video-info-wrap {
      width: 421px;
      height: 342px;
      background: #000000;
      box-shadow: 0px 8px 16px 0px rgba(74, 144, 226, 0.31);
      border-radius: 2px;
      border: 1px solid #4a90e2;
      padding: 33px 20px;
      margin-top: 24px;
      box-sizing: border-box;
      .video {
        margin-top: 40px;
      }
    }
  }
  .event-info {
    font-size: 18px;
    font-weight: 400;
    line-height: 28px;
    .modeDesc {
      margin: 14px 0;
      font-size: 20px;
      color: #f5a623;
    }
  }
  .alarm-details-right {
    padding: 33px 30px;
    position: fixed;
    right: 35%;
    top: 50%;
    transform: translate(100%, -50%);
    width: 421px;
    height: 579px;
    background: #000000;
    box-shadow: 0px 8px 16px 0px rgba(74, 144, 226, 0.31);
    border-radius: 2px;
    border: 1px solid #4a90e2;
    box-sizing: border-box;
    overflow-y: auto;
    &::-webkit-scrollbar-thumb {
      width: 8px;
      background: linear-gradient(180deg, #8bb3ea 0%, #537bd1 100%);
      border-radius: 4px;
    }
    .event-list {
      font-size: 15px;
      margin-top: 30px;
      display: flex;
      align-items: flex-start;
      .time {
        display: flex;
        flex-wrap: nowrap;
        width: 130px;
        color: #add8ff;
        font-size: 16px;
      }
      .info {
        text-align: left;
        flex: 1;
        font-size: 16px;
        font-weight: 400;
        color: #f5a623;
        line-height: 23px;
      }
    }
  }

  .no-data {
    text-align: center;
    width: 100%;
    margin-top: 50px;
    font: 15px;
    color: #dddddd;
  }

  .vdmChart {
    padding: 60px 10px;
    width: 1200px;
    height: 700px;
    position: absolute;
    transform: scale(0.7);
    left: 2000px;
    top: 170px;
    background: black;
    background-color: rgba(7, 13, 13, 0.9);
    // background: url("./img/roadvdm2.png") no-repeat;
    background-size: cover;
    border: 3px solid rgba(50, 152, 223, 0.9);
  }
}
</style>
